<template>
  <div  class="mb-3">
    <b-form-group
      :class="title_position"
      id="example text"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      <select
        v-model="InputName"
        :disabled="FormDataType.Disabled"
        class="form-select"
        :class="{ 'is-invalid': v.$error }"
        type="text"
        @change="$emit('input', $event.target.value)"
      >
        <option value="">{{ $t('OrtakKullanim.seciniz') }}</option>
        <option
          v-for="DataArray in FormDataType.ComboDataArray"
          :key="DataArray.Id"
          :value="DataArray.Id"
          :selected="InputName"
        >
          {{ DataArray.Value }}
        </option>
      </select>
      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{  $t("ValidationMessage.required")  }}</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      InputName: "",
    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: null, 
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
